import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { HomePage } from "./Components/Pages/HomePage/HomePage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HomePage />
);
reportWebVitals();
